import { useMemo } from "react";
import { useGroups } from "../../../../Settings/General/OrganisationLevelGroups/context";
import { useOrgSettingsResourceLabel } from "../../../../../utils/hooks/useOrgSettingsResourceLabel";

export const useGroupColumns = () => {
    const { groups } = useGroups();
    const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

    return useMemo(() => groups.map((group) => ({
        Header: group?.description,
        accessor: group?.level.replace("_", ""),
        Cell: ({ value }) => value ? renderOrgLevelResourceLabel(value) : null,
        // alwaysVisible: group.allocatedBy,
    })), [groups, renderOrgLevelResourceLabel]);
};
